import script from "./vvicMarket.vue?vue&type=script&setup=true&lang=ts"
export * from "./vvicMarket.vue?vue&type=script&setup=true&lang=ts"

import "./vvicMarket.vue?vue&type=style&index=0&id=bee23c2c&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bee23c2c"]])

export default __exports__